import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ConnectComponent } from '../../modals/connect/connect.component';
import { EventService } from '../../services/event.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { WalletConnectService } from '../../services/wallet-connect.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent implements AfterViewInit {
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  isMobile: boolean = false;
  windowSize: number = 0;
  modalRef?: BsModalRef;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
    }
  }
  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private eventService: EventService,
    private modalService: BsModalService,
    private walletConnectService: WalletConnectService,
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
      setTimeout(() => {
        if (this.videoPlayer && this.videoPlayer.nativeElement) {
          setTimeout(() => {
            this.videoPlayer.nativeElement.muted = true;
            this.videoPlayer.nativeElement.play();
          }, 1000);
        }
      }, 1000);
    }
  }

  showWidget(): void {
    if (window.location.pathname.includes('dashboard')) {
      window.scroll({ top: 0 });
      this.connectModal();
    } else {
      this.eventService.showBuyWidget('home');
    }
  }

  connectModal(): void {
    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
    });
  }
  get stakeData() {
    // return this.walletConnectService.stakeData;
    const rawApy = this.walletConnectService.stakeData?.apy ?? 0;
      return rawApy.toFixed(0);
  }
}
